module.exports = __webpack_public_path__ + "static/logo-iBwave-RED-ced0650b0fd3304df19fd2ef1c8f50c8.png";